// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1dyWr","inputWrap":"CustomTip_inputWrap__DdSxO"};